module.exports = __webpack_public_path__ + "static/media/barber_la.cbc79d80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/barber_la.jpg
// module id = 438
// module chunks = 0